export default __webpack_public_path__ + "static/en-2b2812de53a2236665b040ad86d46d3f.svg";